<template>
  <v-app id="inspire">
    <svg  class="bg--img" viewBox="0 0 2195 555">
      <path class="bg--img--fill" d="M 0 553.5L 0 312C 42.5 312 111 295.128 254.332 250.646C 545.657 160.237 908.89 47.3462 1206.52 6.7672C 1504.15 -33.8118 1791.75 122.307 1999.29 99.6872C 2129.79 91.1872 2193.76 69.9872 2193.76 69.9872L 2193.76 553.5L 0 553.5Z" transform="translate(0.707031 0.812752)" fill="#FF6D00"/>
    </svg>

    <s-header :active="active"></s-header>
    <v-content>
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <v-layout column align-center>
            <router-view :key="$route.fullPath" />
            <blockquote>
             
            </blockquote>
          </v-layout>
        </v-slide-y-transition>
      </v-container>
    </v-content>


  </v-app>
</template>

<script>
  import Header from './components/common/Header.vue'
  import utils  from './utils'
  export default {
      data () {
          return {
              active: '',
          }
      },
    components: {
        's-header': Header
    },
      created: function () {
          // `this` points to the vm instance
          this.active = utils.getMainPath(this.$route.path)
          this.$store.dispatch('init')
      },
      mounted: function () {
          this.active = utils.getMainPath(this.$route.path)
      },
      updated: function () {
          this.active = utils.getMainPath(this.$route.path)
      }
  }
</script>


<style scoped>
  .bg--img{
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 0;
  }
  .bg--img--fill{
    fill: #FF6D00;
  }
</style>